(() => {
  if (window.freeShippingBarInitialized) return;
  window.freeShippingBarInitialized = true;

  const BAR_SELECTOR = '[data-free-shipping-bar]';
  const CART_MUTATION_PATHS = ['/cart/change', '/cart/add', '/cart/update', '/cart/clear'];
  const GIFT_REQUEST_HEADER = 'X-Free-Shipping-Bar';
  let refreshTimer;
  let cartRequest;
  let giftSyncInProgress = false;
  let giftUIRefreshTimers = [];
  let pendingGiftAction = null;
  let pendingFreeGiftRequest = null;

  const GIFT_STYLE_ID = 'fsb-gift-styles';
  if (!document.getElementById(GIFT_STYLE_ID)) {
    const style = document.createElement('style');
    style.id = GIFT_STYLE_ID;
    style.textContent = `
      .fsb-gift-item .quantity,
      .fsb-gift-item .cart-item__quantity-wrapper,
      .fsb-gift-item quantity-popover,
      .fsb-gift-item .quantity__button,
      .fsb-gift-item input[name="updates[]"],
      .fsb-gift-item input[type="number"] {
        display: none !important;
        pointer-events: none !important;
      }

      .fsb-gift-badge {
        display: inline-block;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #fff;
        background: rgb(182, 195, 170);
        padding: 3px 8px;
        border-radius: 99px;
        margin-top: 6px;
      }
    `;
    document.head.appendChild(style);
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindShopifyCartEvents();
    queueFreeShippingBarRefresh();
  });

  document.addEventListener('cart:updated', () => queueFreeShippingBarRefresh());
  document.addEventListener('cart:refresh', () => queueFreeShippingBarRefresh());
  document.addEventListener('click', handleCheckoutWhileGiftPending, true);
  document.addEventListener('free-shipping-bar:refresh', (event) => {
    const cart = event.detail && event.detail.cart;

    if (cart && typeof cart.total_price === 'number') {
      hideBarsWhenNoQualifyingItems(cart);
      clearTimeout(refreshTimer);
      initFreeShippingBars(cart);
      return;
    }

    queueFreeShippingBarRefresh();
  });

  patchFetch();

  function bindShopifyCartEvents() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'free-shipping-bar') return;

      if (event.cartData && typeof event.cartData.total_price === 'number') {
        hideBarsWhenNoQualifyingItems(event.cartData);
        clearTimeout(refreshTimer);
        initFreeShippingBars(event.cartData);
        return;
      }

      queueFreeShippingBarRefresh();
    });
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.freeShippingBarPatched) return;

    const originalFetch = window.fetch.bind(window);
    const patchedFetch = async (...args) => {
      const response = await originalFetch(...args);
      const url = getFetchUrl(args[0]);

      if (!isGiftMutationRequest(args[1]) && CART_MUTATION_PATHS.some((path) => url.includes(path))) {
        queueFreeShippingBarRefresh();
      }

      return response;
    };

    patchedFetch.freeShippingBarPatched = true;
    window.fetch = patchedFetch;
  }

  function getFetchUrl(input) {
    if (typeof input === 'string') return input;
    return input && input.url ? input.url : '';
  }

  function isGiftMutationRequest(options) {
    const headers = options && options.headers;
    if (!headers) return false;
    if (typeof Headers !== 'undefined' && headers instanceof Headers) {
      return headers.get(GIFT_REQUEST_HEADER) === 'true';
    }
    return headers[GIFT_REQUEST_HEADER] === 'true';
  }

  function getGiftMutationHeaders() {
    return {
      'Content-Type': 'application/json',
      [GIFT_REQUEST_HEADER]: 'true',
    };
  }

  function queueFreeShippingBarRefresh(delay = 0) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      initFreeShippingBars();
    }, delay);
  }

function hasCateringDeliveryItemInDOM() {
  return Array.from(document.querySelectorAll('.cart-item[data-product-tags]')).some((item) =>
    item.dataset.productTags
      .split(',')
      .map((tag) => tag.trim().toLowerCase())
      .includes('cateringdel')
  );
}

  function hideBarsWhenNoQualifyingItems(cart) {
    const bars = Array.from(document.querySelectorAll(BAR_SELECTOR));
    if (!bars.length) return;

    const giftVariantId = getConfiguredGiftVariantId(bars[0]);

    if (hasCateringDeliveryItemInDOM()) {
      bars.forEach((bar) => {
        bar.hidden = true;
      });
      return;
    }
    
    const hasQualifyingItems = Array.isArray(cart.items) && cart.items.some((item) => !isGiftVariant(item, giftVariantId));
    if (hasQualifyingItems) return;

    bars.forEach((bar) => {
      bar.hidden = true;
    });
  }

  async function initFreeShippingBars(cartData) {
    const bars = Array.from(document.querySelectorAll(BAR_SELECTOR));
    if (!bars.length) return;

    try {
      const cart = cartData || (await getCart());
      const giftVariantId = getConfiguredGiftVariantId(bars[0]);
      bars.forEach((bar) => updateBar(bar, cart, giftVariantId));

      if (!giftSyncInProgress) {
        giftSyncInProgress = true;
        try {
          syncGift(cart, bars[0], giftVariantId);
        } finally {
          giftSyncInProgress = false;
        }
      }

      queueGiftUIRefresh(giftVariantId);
    } catch (error) {
      console.error('Free shipping bar error:', error);
    }
  }

  async function getCart() {
    if (!cartRequest) {
      cartRequest = fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      })
        .then((response) => response.json())
        .finally(() => {
          cartRequest = null;
        });
    }

    return cartRequest;
  }

  function applyGiftUI(variantId) {
    if (!variantId) return;

    const allCartItems = document.querySelectorAll([
      'tr.cart-item',
      'li.cart-item',
      '.cart-item',
      '[data-cart-item]',
      '.cart-drawer__item',
    ].join(', '));

    allCartItems.forEach((item) => {
      const variantInput =
        item.querySelector('input[name="id"]') ||
        item.querySelector('[data-quantity-variant-id]') ||
        item.querySelector('[data-variant-id]') ||
        item.querySelector('[name="id"]');

      const itemVariantId =
        variantInput?.value ||
        variantInput?.dataset?.quantityVariantId ||
        variantInput?.dataset?.variantId ||
        item.dataset?.variantId ||
        item.dataset?.productVariantId;

      if (String(itemVariantId) !== String(variantId)) return;

      item.classList.add('fsb-gift-item');

      const detailsEl = item.querySelector('.cart-item__details');
      const nameEl = item.querySelector('.cart-item__name') || item.querySelector('a');
      const titleEl = detailsEl || nameEl;

      if (titleEl && !titleEl.querySelector('.fsb-gift-badge')) {
        const badge = document.createElement('span');
        badge.className = 'fsb-gift-badge';
        badge.textContent = 'Free Gift';
        if (detailsEl && nameEl) {
          nameEl.insertAdjacentElement('afterend', badge);
        } else {
          titleEl.appendChild(badge);
        }
      }
    });
  }

  function queueGiftUIRefresh(variantId) {
    giftUIRefreshTimers.forEach((timer) => clearTimeout(timer));
    giftUIRefreshTimers = [];

    applyGiftUI(variantId);
    giftUIRefreshTimers = [50, 150, 300, 600].map((delay) =>
      setTimeout(() => applyGiftUI(variantId), delay)
    );
  }

  function updateBar(bar, cart, resolvedGiftVariantId) {
    if (hasCateringDeliveryItemInDOM()) {
      bar.hidden = true;
      return;
    }
    const giftVariantId = resolvedGiftVariantId || getConfiguredGiftVariantId(bar);
    const hasQualifyingItems = Array.isArray(cart.items) && cart.items.some((item) => !isGiftVariant(item, giftVariantId));

    if (!hasQualifyingItems) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;

    const shippingThreshold = parseCents(bar.dataset.shippingThreshold);
    const giftEnabled = bar.dataset.giftEnabled === 'true';
    const giftThreshold = parseCents(bar.dataset.giftThreshold);
    const maxThreshold = parseCents(bar.dataset.maxThreshold) || shippingThreshold;

    const messageEl = bar.querySelector('[data-fsb-message]');
    const fillEl = bar.querySelector('[data-fsb-fill]');
    const shippingMilestone = bar.querySelector('[data-milestone="shipping"]');
    const giftMilestone = bar.querySelector('[data-milestone="gift"]');

    if (!messageEl || !fillEl || !shippingMilestone || !shippingThreshold || !maxThreshold) return;

    const subtotal = getQualifyingSubtotal(cart, giftVariantId);
    const progress = Math.min((subtotal / maxThreshold) * 100, 100);

    fillEl.style.width = `${progress}%`;
    messageEl.hidden = false;

    if (giftEnabled && giftThreshold > 0 && subtotal >= giftThreshold) {
      messageEl.textContent = 'Free gift unlocked + FREE shipping*';
      unlockMilestone(giftMilestone);
      unlockMilestone(shippingMilestone);
    } else if (subtotal >= shippingThreshold) {
      if (giftEnabled && giftThreshold > 0 && giftThreshold > subtotal) {
        const giftRemaining = giftThreshold - subtotal;
        messageEl.textContent = `You've unlocked FREE shipping!* & You're ${formatMoney(giftRemaining)} away from your free gift`;
      } else {
        messageEl.textContent = "You've unlocked FREE shipping!*";
      }
      unlockMilestone(shippingMilestone);
      giftMilestone?.classList.remove('is-unlocked', 'is-animating');
    } else {
      const remaining = shippingThreshold - subtotal;
      messageEl.textContent = `You're ${formatMoney(remaining)} away from FREE shipping*`;
      shippingMilestone.classList.remove('is-unlocked', 'is-animating');
      giftMilestone?.classList.remove('is-unlocked', 'is-animating');
    }
  }

  function syncGift(cart, bar, resolvedGiftVariantId) {
    if (!bar) return;

    const giftEnabled = bar.dataset.giftEnabled === 'true';
    const giftThreshold = parseCents(bar.dataset.giftThreshold);
    const giftVariantId = resolvedGiftVariantId || getConfiguredGiftVariantId(bar);
    const subtotal = getQualifyingSubtotal(cart, giftVariantId);
    const hasGift = hasGiftInCart(cart, giftVariantId);

    if (!isValidVariantId(giftVariantId)) return;

    if (hasCateringDeliveryItemInDOM()) {
      optimisticHideGift(giftVariantId);
      if (hasGift && pendingGiftAction !== 'remove') {
        trackGiftRequest('remove', removeFreeGift(cart, giftVariantId));
      }
      return;
    }

    if (!giftEnabled || giftThreshold <= 0) {
      optimisticHideGift(giftVariantId);
      if (hasGift && pendingGiftAction !== 'remove') {
        trackGiftRequest('remove', removeFreeGift(cart, giftVariantId));
      }
      return;
    }

    if (subtotal >= giftThreshold) {
      optimisticShowGift(bar, giftVariantId);

      if (!hasGift && pendingGiftAction !== 'add') {
        trackGiftRequest('add', addFreeGift(cart, giftVariantId));
      } else if (hasGift) {
        enforceGiftQuantity(cart, giftVariantId);
      }
    } else {
      optimisticHideGift(giftVariantId);
      if (hasGift && pendingGiftAction !== 'remove') {
        trackGiftRequest('remove', removeFreeGift(cart, giftVariantId));
      }
    }
  }

  function hasGiftInCart(cart, variantId) {
    return Array.isArray(cart.items) && cart.items.some((item) => isGiftVariant(item, variantId));
  }

  function trackGiftRequest(action, request) {
    pendingGiftAction = action;
    const trackedRequest = Promise.resolve(request)
      .then((success) => {
        if (!success) queueFreeShippingBarRefresh();
        return success;
      })
      .catch((error) => {
        console.error('Free gift sync failed:', error);
        queueFreeShippingBarRefresh();
        return false;
      })
      .finally(() => {
        if (pendingFreeGiftRequest !== trackedRequest) return;
        pendingGiftAction = null;
        pendingFreeGiftRequest = null;
        window.pendingFreeGiftRequest = null;
      });

    pendingFreeGiftRequest = trackedRequest;
    window.pendingFreeGiftRequest = trackedRequest;
    return trackedRequest;
  }

  async function handleCheckoutWhileGiftPending(event) {
    const checkoutButton = event.target?.closest?.('[name="checkout"], .cart__checkout-button, a[href="/checkout"], a[href*="/checkout"]');
    if (!checkoutButton || !pendingFreeGiftRequest) return;

    event.preventDefault();
    event.stopPropagation();
    checkoutButton.setAttribute('aria-disabled', 'true');
    checkoutButton.classList.add('loading');

    try {
      await pendingFreeGiftRequest;
    } finally {
      window.location.href = '/checkout';
    }
  }

  function optimisticShowGift(bar, variantId) {
    if (!variantId) return;
    const meta = getGiftProductMeta(bar);

    insertOptimisticGiftRow(document.querySelector('#CartDrawer-CartItems tbody'), variantId, meta, 'drawer');
    insertOptimisticGiftRow(document.querySelector('#main-cart-items tbody'), variantId, meta, 'cart');
    queueGiftUIRefresh(variantId);
  }

  function optimisticHideGift(variantId) {
    if (!variantId) return;

    document.querySelectorAll('tr.cart-item').forEach((row) => {
      if (getCartRowVariantId(row) === String(variantId)) row.remove();
    });
  }

  function insertOptimisticGiftRow(tbody, variantId, meta, context) {
    if (!tbody || hasGiftRow(tbody, variantId)) return;

    const row = document.createElement('tr');
    row.className = 'cart-item fsb-gift-item fsb-gift-item--optimistic';
    row.dataset.variantId = String(variantId);
    row.dataset.fsbOptimisticGift = 'true';
    row.innerHTML = context === 'drawer' ? getDrawerGiftRowHTML(meta) : getCartGiftRowHTML(meta);
    tbody.prepend(row);
  }

  function getGiftProductMeta(bar) {
    return {
      title: bar?.dataset.giftProductTitle || 'Free Gift',
      url: bar?.dataset.giftProductUrl || '#',
      image: bar?.dataset.giftProductImage || '',
    };
  }

  function getDrawerGiftRowHTML(meta) {
    return `
      <td class="cart-item__media" role="cell">
        ${getGiftImageHTML(meta)}
      </td>
      <td class="cart-item__details" role="cell">
        <span class="cart-item__name h4 break">${escapeHTML(meta.title)}</span>
        <span class="fsb-gift-badge">Free Gift</span>
        <div class="product-option">$0.00</div>
      </td>
      <td class="cart-item__totals right" role="cell">
        <div class="cart-item__price-wrapper"><span class="price price--end">$0.00</span></div>
      </td>
      <td class="cart-item__quantity" role="cell"></td>
    `;
  }

  function getCartGiftRowHTML(meta) {
    return `
      <td class="cart-item__media">
        <div class="cart-item__image-container gradient global-media-settings">${getGiftImageHTML(meta)}</div>
      </td>
      <td class="cart-item__details">
        <span class="cart-item__name h4 break">${escapeHTML(meta.title)}</span>
        <span class="fsb-gift-badge">Free Gift</span>
        <div class="product-option">$0.00</div>
      </td>
      <td class="cart-item__totals right medium-hide large-up-hide">
        <div class="cart-item__price-wrapper"><span class="price price--end">$0.00</span></div>
      </td>
      <td class="cart-item__quantity"></td>
      <td class="cart-item__totals right small-hide">
        <div class="cart-item__price-wrapper"><span class="price price--end">$0.00</span></div>
      </td>
    `;
  }

  function getGiftImageHTML(meta) {
    if (!meta.image) return '';
    return `<img class="cart-item__image" src="${escapeAttribute(meta.image)}" alt="${escapeAttribute(meta.title)}" loading="eager" width="150" height="150">`;
  }

  function hasGiftRow(tbody, variantId) {
    return Array.from(tbody.querySelectorAll('tr.cart-item')).some((row) => getCartRowVariantId(row) === String(variantId));
  }

  function getCartRowVariantId(row) {
    const variantEl = row.querySelector('[data-quantity-variant-id], [data-variant-id], input[name="id"], [name="id"]');
    return String(
      row.dataset.variantId ||
        variantEl?.dataset.quantityVariantId ||
        variantEl?.dataset.variantId ||
        variantEl?.value ||
        ''
    );
  }

  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[char]);
  }

  function escapeAttribute(value) {
    return escapeHTML(value);
  }

  async function addFreeGift(cart, variantId) {
    const alreadyInCart = cart.items.some((item) => isGiftVariant(item, variantId));
    if (alreadyInCart) return true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: getGiftMutationHeaders(),
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: { _gift: 'true' },
            },
          ],
          sections: getGiftSectionIds(),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) {
        console.warn('Gift add failed. Check the free gift product handle in theme settings.');
        return false;
      }

      notifyCartChanged(await response.json());
      return true;
    } catch (error) {
      console.error('Error adding free gift:', error);
      return false;
    }
  }

  async function enforceGiftQuantity(cart, variantId) {
    const giftItems = cart.items.filter((item) => isGiftVariant(item, variantId));
    if (!giftItems.length) return true;

    let cartChanged = false;
    let success = true;

    for (const giftItem of giftItems.slice(1)) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: getGiftMutationHeaders(),
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0,
            sections: getGiftSectionIds(),
            sections_url: window.location.pathname,
          }),
        });

        if (response.ok) {
          cartChanged = true;
          notifyCartChanged(await response.json());
        } else {
          success = false;
        }
      } catch (error) {
        console.error('Error removing duplicate gift:', error);
        success = false;
      }
    }

    const giftItem = giftItems[0];

    if (giftItem.quantity > 1) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: getGiftMutationHeaders(),
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 1,
            sections: getGiftSectionIds(),
            sections_url: window.location.pathname,
          }),
        });

        if (response.ok) {
          cartChanged = true;
          notifyCartChanged(await response.json());
        } else {
          success = false;
        }
      } catch (error) {
        console.error('Error enforcing gift quantity:', error);
        success = false;
      }
    }

    if (cartChanged) queueGiftUIRefresh(variantId);
    return success;
  }

  async function removeFreeGift(cart, variantId) {
    const giftItems = cart.items.filter((item) => isGiftVariant(item, variantId));
    if (!giftItems.length) return true;

    let cartChanged = false;
    let success = true;

    for (const giftItem of giftItems) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: getGiftMutationHeaders(),
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0,
            sections: getGiftSectionIds(),
            sections_url: window.location.pathname,
          }),
        });

        if (response.ok) {
          cartChanged = true;
          notifyCartChanged(await response.json());
        } else {
          success = false;
        }
      } catch (error) {
        console.error('Error removing free gift:', error);
        success = false;
      }
    }

    if (cartChanged) queueGiftUIRefresh(variantId);
    return success;
  }

  function getGiftSectionsToRender() {
    const sections = [
      { id: 'cart-drawer', type: 'drawer' },
      { id: 'cart-icon-bubble', type: 'inner', selector: '.shopify-section' },
    ];
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems?.dataset.id) {
      sections.push({ id: mainCartItems.dataset.id, type: 'cart-items', selector: 'cart-items' });
    }

    if (mainCartFooter?.dataset.id) {
      sections.push({ id: mainCartFooter.dataset.id, type: 'inner', selector: '#main-cart-footer' });
    }

    return sections;
  }

  function getGiftSectionIds() {
    return getGiftSectionsToRender().map((section) => section.id);
  }

  function notifyCartChanged(cartData) {
    const renderedSections = renderGiftSections(cartData);

    if (cartData && typeof cartData.total_price === 'number') {
      document.dispatchEvent(
        new CustomEvent('free-shipping-bar:refresh', {
          detail: { cart: cartData },
        })
      );
    }

    if (renderedSections || typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-shipping-bar', cartData });
  }

  function renderGiftSections(cartData) {
    if (!cartData?.sections) return false;

    let requiredSections = 0;
    let renderedSections = 0;

    getGiftSectionsToRender().forEach((section) => {
      const hasTarget =
        section.type === 'drawer'
          ? Boolean(document.querySelector('cart-drawer-items'))
          : section.id === 'cart-icon-bubble'
            ? Boolean(document.getElementById('cart-icon-bubble'))
            : section.type === 'cart-items'
              ? Boolean(document.querySelector('cart-items'))
              : Boolean(document.querySelector(section.selector));

      if (!hasTarget) return;
      requiredSections += 1;

      const html = cartData.sections[section.id];
      if (!html) return;

      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      if (section.type === 'drawer') {
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        let drawerRendered = false;

        selectors.forEach((selector) => {
          const target = document.querySelector(selector);
          const source = parsedHTML.querySelector(selector);
          if (!target || !source) return;

          target.replaceWith(source);
          drawerRendered = true;
        });

        const drawer = document.querySelector('cart-drawer');
        const sourceDrawer = parsedHTML.querySelector('cart-drawer');
        if (drawer && sourceDrawer) drawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
        if (!drawerRendered) return;

        renderedSections += 1;
        return;
      }

      const source = parsedHTML.querySelector(section.selector);
      if (!source) return;

      if (section.id === 'cart-icon-bubble') {
        const target = document.getElementById('cart-icon-bubble');
        if (!target) return;

        target.innerHTML = source.innerHTML;
        renderedSections += 1;
        return;
      }

      if (section.type === 'cart-items') {
        const target = document.querySelector('cart-items');
        if (!target) return;

        const targetContent = target.querySelector('.page-width');
        const sourceContent = source.querySelector('.page-width');

        if (targetContent && sourceContent) {
          targetContent.replaceWith(sourceContent);
        } else {
          target.innerHTML = source.innerHTML;
        }

        target.className = source.className;
        renderedSections += 1;
        return;
      }

      const target = document.querySelector(section.selector);
      if (!target) return;

      target.innerHTML = source.innerHTML;
      target.className = source.className;
      renderedSections += 1;
    });

    queueGiftUIRefresh(getConfiguredGiftVariantId(document.querySelector(BAR_SELECTOR) || { dataset: {} }));
    return requiredSections > 0 && renderedSections === requiredSections;
  }

  function getQualifyingSubtotal(cart, giftVariantId) {
    if (!Array.isArray(cart.items)) return cart.total_price || 0;

    return cart.items.reduce((total, item) => {
      if (isGiftVariant(item, giftVariantId)) return total;
      return total + (item.final_line_price ?? item.line_price ?? 0);
    }, 0);
  }

  function isGiftVariant(item, variantId) {
    return String(item.variant_id) === String(variantId);
  }

  function isValidVariantId(variantId) {
    return variantId && variantId !== '1234' && /^\d+$/.test(String(variantId));
  }

  function getConfiguredGiftVariantId(bar) {
    return (bar.dataset.giftVariantId || '').trim();
  }

  function unlockMilestone(el) {
    if (!el) return;

    if (!el.classList.contains('is-unlocked')) {
      el.classList.add('is-unlocked', 'is-animating');
      setTimeout(() => el.classList.remove('is-animating'), 600);
    }
  }

  function parseCents(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  window.refreshFreeShippingBar = queueFreeShippingBarRefresh;
})();
